/**
 * The desktop app.
 *
 * Served from /srv/contexto/downloads rather than the built bundle, because
 * the deploy rebuilds apps/web/dist and would delete anything placed there.
 */
export const MAC_DOWNLOAD = '/downloads/ContextoAgent-arm64.dmg';
